/*
 * /after-tooth-extraction — живая шкала восстановления после удаления зуба.
 *
 * Спрос («после удаления зуба» — 495 471 показов/мес в РФ) закрыт статьями
 * клиник. Статья отвечает на вопрос «что бывает вообще»; человек с ватой во
 * рту спрашивает другое: «сейчас 14:20, мне УЖЕ можно есть?».
 *
 * Поэтому здесь три вещи, которых нет ни у одной статьи:
 *
 *  1. ЗАПРЕТЫ С ОБРАТНЫМ ОТСЧЁТОМ. Человек помнит «нельзя полоскать», но не
 *     помнит, сколько именно, и полощет на второй час, вымывая сгусток.
 *  2. ОКНО СУХОЙ ЛУНКИ отдельной строкой с признаком, по которому её
 *     отличают от нормальной боли: боль СНАЧАЛА УТИХАЛА, а на 3–4-е сутки
 *     усилилась. Это единственный различающий признак, и в статьях он тонет.
 *  3. ЗАМОРОЗКА И ЕДА СЦЕПЛЕНЫ. Пока держится анестезия, есть опасно: щёку
 *     и язык прикусывают, не чувствуя. «Через 2 часа можно есть» без этой
 *     оговорки — вредный совет.
 *
 * ⛔ Тул не назначает лекарства и не называет доз. Интервал приёма человек
 * вводит САМ — тот, что назвал врач; мы только считаем время.
 */

import { downloadIcs } from '../ics-simple.js';

const CFG = window.__AFTER_EXTRACTION || {};
const T = CFG.i18n || {};
const $ = s => document.querySelector(s);
const $$ = s => Array.from(document.querySelectorAll(s));

const KEY = 'after-tooth-extraction:v1';
const H = 3600000;

const state = {
    at: null,          // момент удаления (Date)
    kind: 'simple',
    tooth: '',
    painAt: null,      // когда приняли обезболивающее
    painEvery: 8,      // интервал в часах — со слов врача
    smoker: false,
};

let tick = null;

// ── запуск ──────────────────────────────────────────────────────────────

function boot() {
    restore();
    wireInputs();
    wireActions();
    render();
    // Раз в 30 с: шкала должна оставаться правдой, пока вкладка открыта.
    tick = setInterval(render, 30000);
    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) render();
    });
    if (window.__stage) window.__stage('ready');
}

function restore() {
    try {
        const raw = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (raw && raw.at) {
            state.at = new Date(raw.at);
            state.kind = raw.kind || 'simple';
            state.tooth = raw.tooth || '';
            state.painAt = raw.painAt ? new Date(raw.painAt) : null;
            state.painEvery = raw.painEvery || 8;
            state.smoker = !!raw.smoker;
        }
    } catch (_) {}

    if (state.at) {
        $('#aeWhen').value = toLocalInput(state.at);
        $('#aeTooth').value = state.tooth;
        $('#aePainEvery').value = state.painEvery;
        $('#aeSmoker').checked = state.smoker;
    } else {
        // Умолчание — «сейчас, минус полчаса»: человек открывает тул по
        // дороге из клиники, а не в момент удаления.
        const d = new Date(Date.now() - 30 * 60000);
        d.setSeconds(0, 0);
        $('#aeWhen').value = toLocalInput(d);
    }
    syncKind();
}

function save() {
    try {
        localStorage.setItem(KEY, JSON.stringify({
            at: state.at ? state.at.toISOString() : null,
            kind: state.kind, tooth: state.tooth,
            painAt: state.painAt ? state.painAt.toISOString() : null,
            painEvery: state.painEvery, smoker: state.smoker,
        }));
    } catch (_) {}
}

function wireInputs() {
    $('#aeWhen').addEventListener('change', () => {
        const v = $('#aeWhen').value;
        state.at = v ? new Date(v) : null;
        save(); render();
        if (window.__aeFunnel) window.__aeFunnel('time_set', { kind: state.kind });
    });

    $('#aeKind').addEventListener('click', e => {
        const b = e.target.closest('[data-val]');
        if (!b) return;
        state.kind = b.getAttribute('data-val');
        syncKind(); save(); render();
    });

    $('#aeTooth').addEventListener('input', () => {
        state.tooth = $('#aeTooth').value.trim();
        save(); renderTooth();
    });

    $('#aePainEvery').addEventListener('change', () => {
        state.painEvery = Math.max(1, Math.min(24, +$('#aePainEvery').value || 8));
        $('#aePainEvery').value = state.painEvery;
        save(); render();
    });

    $('#aeSmoker').addEventListener('change', () => {
        state.smoker = $('#aeSmoker').checked;
        save(); render();
    });
}

function syncKind() {
    $$('#aeKind [data-val]').forEach(b => {
        const on = b.getAttribute('data-val') === state.kind;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
}

function wireActions() {
    $('#aePainTook').addEventListener('click', () => {
        state.painAt = new Date();
        save(); render();
        window.__toast && window.__toast(T.pain_noted, 'success');
        if (window.__aeFunnel) window.__aeFunnel('pain_logged', { every: state.painEvery || 0 });
    });

    $('#aePainReset').addEventListener('click', () => {
        state.painAt = null; save(); render();
    });

    $('#aeIcs').addEventListener('click', () => {
        if (!state.at) return;
        const events = steps()
            .filter(s => s.when > new Date())
            .map(s => ({
                start: s.when,
                summary: T.ics_prefix + ': ' + s.title,
                description: s.text,
                alarmMinutes: 0,
            }));
        const n = downloadIcs(events, {
            name: T.ics_prefix,
            prodid: 'after-tooth-extraction',
            filename: 'after-tooth-extraction',
        });
        if (!n) window.__toast && window.__toast(T.ics_none, 'info');
        else if (window.__aeToolComplete) window.__aeToolComplete({ ok: 1, kind: 'ics', n });
    });

    $('#aeCopy').addEventListener('click', async () => {
        // Текст для сообщения в клинику: человек, встревоженный ночью, не
        // должен ещё и формулировать. Пишем факты — время, вид, что беспокоит.
        const flags = $$('#aeFlags input:checked').map(i => i.dataset.label);
        const hrs = state.at ? ((Date.now() - state.at) / H) : 0;
        const text = [
            T.msg_head,
            fmt(T.msg_when, { hours: Math.floor(hrs), date: state.at ? state.at.toLocaleString(window.__LOCALE || 'ru') : '—' }),
            state.tooth ? fmt(T.msg_tooth, { tooth: state.tooth }) : '',
            flags.length ? T.msg_flags + ' ' + flags.join('; ') : T.msg_noflags,
        ].filter(Boolean).join('\n');
        try {
            await navigator.clipboard.writeText(text);
            window.__toast && window.__toast(T.copied, 'success');
        } catch (e) {
            window.__handleError(e, 'after-extraction:copy');
        }
    });

    $('#aeReset').addEventListener('click', () => {
        state.at = null; state.painAt = null;
        try { localStorage.removeItem(KEY); } catch (_) {}
        location.reload();
    });

    /*
     * Красные флаги — единственная часть тула, которая может отправить
     * человека к врачу СЕГОДНЯ, а не через неделю. Сколько раз она
     * срабатывает и на чём — вопрос безопасности, а не любопытства.
     */
    $('#aeFlags').addEventListener('change', e => {
        renderFlags();
        const on = $$('#aeFlags input:checked').length;
        if (on && window.__aeFunnel) {
            window.__aeFunnel('red_flag', { n: on, flag: (e.target && e.target.id) || '' });
        }
    });
}

// ── расчёт ──────────────────────────────────────────────────────────────

function elapsed() {
    return state.at ? (Date.now() - state.at.getTime()) / H : null;
}

function steps() {
    if (!state.at) return [];
    return CFG.steps
        .filter(s => s.kinds.includes(state.kind))
        .map(s => ({
            key: s.key,
            at: s.at,
            severity: s.severity || null,
            when: new Date(state.at.getTime() + s.at * H),
            title: T.step[s.key] ? T.step[s.key].t : s.key,
            text: T.step[s.key] ? T.step[s.key].d : '',
        }));
}

function donts() {
    const e = elapsed();
    return CFG.donts.map(d => {
        // Курение — единственный запрет, который мы удлиняем осознанно:
        // курящие дают самый высокий риск сухой лунки, и им же виден
        // обратный отсчёт, а не абстрактное «поменьше курите».
        const until = (d.key === 'smoke' && state.smoker) ? Math.max(d.until, 96) : d.until;
        return { key: d.key, until, left: e == null ? null : until - e };
    });
}

// ── отрисовка ───────────────────────────────────────────────────────────

function render() {
    const e = elapsed();
    const has = e != null;

    $('#aeNoTime').hidden = has;
    $('#aeBody').hidden = !has;
    if (!has) return;

    // Шапка: сколько прошло и что происходит сейчас.
    $('#aeElapsed').textContent = e < 0 ? T.not_yet : humanSpan(e);

    const all = steps();
    const done = all.filter(s => s.at <= e);
    const next = all.find(s => s.at > e);

    $('#aeNow').textContent = done.length ? done[done.length - 1].title : T.now_start;
    $('#aeNext').textContent = next
        ? fmt(T.next_in, { what: next.title, when: humanSpan(next.at - e) })
        : T.next_none;

    renderDonts(e);
    renderNumb(e);
    renderPain();
    renderTimeline(all, e);
    renderDrySocket(e);
    renderTooth();
}

/** Главный блок: что нельзя ПРЯМО СЕЙЧАС и сколько ещё. */
function renderDonts(e) {
    const box = $('#aeDonts');
    box.textContent = '';
    const active = donts().filter(d => d.left > 0);

    $('#aeDontsFree').hidden = active.length > 0;
    if (!active.length) return;

    active.sort((a, b) => a.left - b.left);
    for (const d of active) {
        const li = document.createElement('li');
        li.className = 'ae-dont';
        const t = document.createElement('b');
        t.textContent = T.dont[d.key] || d.key;
        const s = document.createElement('span');
        s.textContent = fmt(T.dont_left, { left: humanSpan(d.left) });
        li.append(t, s);
        box.appendChild(li);
    }
}

/**
 * Заморозка и еда — сцепка, а не два независимых пункта. Пока не чувствуешь
 * щёку, есть опасно: её прикусывают, не замечая, и приходят с раной.
 */
function renderNumb(e) {
    const box = $('#aeNumb');
    const numbHours = 2;
    if (e < numbHours) {
        box.hidden = false;
        box.className = 'ae-note ae-note-warn';
        box.textContent = fmt(T.numb_on, { left: humanSpan(numbHours - e) });
    } else if (e < 4) {
        box.hidden = false;
        box.className = 'ae-note';
        box.textContent = T.numb_off;
    } else {
        box.hidden = true;
    }
}

function renderPain() {
    const box = $('#aePainState');
    if (!state.painAt) {
        box.textContent = T.pain_none;
        $('#aePainReset').hidden = true;
        return;
    }
    $('#aePainReset').hidden = false;
    const since = (Date.now() - state.painAt.getTime()) / H;
    const left = state.painEvery - since;
    box.textContent = left > 0
        ? fmt(T.pain_wait, { left: humanSpan(left), taken: state.painAt.toLocaleTimeString(window.__LOCALE || 'ru', { hour: '2-digit', minute: '2-digit' }) })
        : fmt(T.pain_ok, { taken: state.painAt.toLocaleTimeString(window.__LOCALE || 'ru', { hour: '2-digit', minute: '2-digit' }) });
}

function renderTimeline(all, e) {
    const box = $('#aeTimeline');
    box.textContent = '';
    for (const s of all) {
        const li = document.createElement('li');
        const past = s.at <= e;
        li.className = 'ae-step' + (past ? ' is-past' : '') + (s.severity === 'red' ? ' is-red' : '');

        const time = document.createElement('span');
        time.className = 'ae-step-t';
        time.textContent = s.when.toLocaleString(window.__LOCALE || 'ru',
            { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });

        const body = document.createElement('div');
        const h = document.createElement('b');
        h.textContent = s.title;
        const p = document.createElement('span');
        p.textContent = s.text;
        body.append(h, p);

        li.append(time, body);
        box.appendChild(li);
    }
}

/**
 * Сухая лунка. Отличается от нормальной боли ОДНИМ признаком: боль сначала
 * шла на убыль, а на третьи-четвёртые сутки усилилась. В статьях этот
 * признак тонет среди прочих симптомов — здесь он вынесен отдельно и
 * показывается ровно в своё окно.
 */
function renderDrySocket(e) {
    const box = $('#aeDry');
    const inWindow = e >= 48 && e <= 144;
    box.hidden = !inWindow;
    if (inWindow) box.querySelector('[data-hours]').textContent = fmt(T.dry_window, { day: Math.floor(e / 24) + 1 });
}

function renderTooth() {
    const link = $('#aeToothLink');
    const raw = String(state.tooth || '').replace(/[\s.]/g, '');
    const known = CFG.teethSet.includes(raw);
    link.hidden = !known;
    if (known) {
        link.href = CFG.chartUrl;
        link.textContent = fmt(T.tooth_link, { tooth: CFG.names[raw] || raw });
    }
}

function renderFlags() {
    const any = $$('#aeFlags input:checked').length > 0;
    $('#aeFlagsCall').hidden = !any;
}

// ── мелочи ──────────────────────────────────────────────────────────────

function humanSpan(hours) {
    const abs = Math.abs(hours);
    if (abs < 1) {
        const n = Math.max(1, Math.round(abs * 60));
        return n === 60 ? fmt(T.span_h, { h: 1 }) : fmt(T.span_min, { n });
    }
    if (abs < 48) {
        // ⚠️ Округление минут даёт 60, а не 0 с переносом: доля 0.999 часа
        // печаталась как «45 ч 60 мин». Найдено живым прогоном шкалы, не
        // синтетикой — в синтетике доли ровные.
        let h = Math.floor(abs);
        let m = Math.round((abs - h) * 60);
        if (m >= 60) { h += 1; m = 0; }
        if (h >= 48) return fmt(T.span_d, { d: 2 });
        return m ? fmt(T.span_hm, { h, m }) : fmt(T.span_h, { h });
    }
    return fmt(T.span_d, { d: Math.round(abs / 24) });
}

function toLocalInput(d) {
    const p = n => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}

function fmt(tpl, vars) {
    return String(tpl || '').replace(/:(\w+)/g, (m, k) => (k in vars ? String(vars[k]) : m));
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
} else {
    boot();
}
